<div class="container-fluid bg-footer text-center mt-5"> <span>CONTROLADORIA GERAL DO ESTADO DE GÓIAS - CGE</span> </div>
